export const teresaQuotes = {
  initial: {
    id: 0,
    lines: [
      "Мы наблюдали за тобой.",
      "Ты показал надежду своей способностью гнуть Реальность.",
      "Мы - Божества, и мы хотим чтобы ты присоединился к нам.",
      "Меня зовут Тереза, Божество Реальности.",
      "Докажи свою ценность.",
    ]
  },
  unlockReality: {
    id: 1,
    lines: [
      "Я впущу тебя в свою Реальность, смертный, попытайся не погибнуть внутри неё."
    ]
  },
  completeReality: {
    id: 2,
    lines: [
      "Почему ты всё ещё здесь... ты должен был провалиться."
    ]
  },
  effarig: {
    id: 3,
    lines: [
      "Ты всё ещё нам не ровня.",
      "Я надеюсь другие будут иметь успех там, где не получилось у меня."
    ]
  }
};
